import './Footer.css'

export function Footer() {
    return(
        <footer>
            <span>Copyright © 2022 | dev.xcheko51x</span>
        </footer>
    );
}